export default "__VITE_ASSET__1f110547__"